import React from 'react'

const Button = (props) => {
  const { prevar, feno, filterType, fen, buttonHandler } = props;
  return (
    <button
      className={prevar[feno.variable].includes(fen.id) ? 'btnCharacteristicsOn' : 'btnCharacteristicsOff'}
      onClick={() => buttonHandler({ ...fen, variable: feno.variable }, filterType)}
    >
      <div className='btnIntern'>
        {fen.title}
      </div>
    </button>
  )
}

export default Button;